'use client'
import type { DefaultCellComponentProps } from 'payload'

import { formatEuro } from '@/negozio/prezzi'

/** List cell for an amount in integer cents. */
export const CellaEuro: React.FC<DefaultCellComponentProps> = ({ cellData }) =>
  Number.isSafeInteger(cellData) ? <span>{formatEuro(cellData as number)}</span> : null
